import React from 'react'

import { Descriptions } from 'antd'
import dayjs from 'dayjs'
import { ColorType } from 'metrics-chart'

import {
  ClusterCluster,
  OldreportTrafficComparisonReport
} from '@clinic/client'

import { useOrgAndCluster } from '../shared/context'
import { formatDuration } from '../shared/utils'

interface BasicConfigurationProps {
  data: OldreportTrafficComparisonReport
  clusterInfo1?: ClusterCluster
  clusterInfo2?: ClusterCluster
}

export const BasicConfiguration: React.FC<BasicConfigurationProps> = ({
  data
}) => {
  const { cluster1, cluster2 } = useOrgAndCluster()
  return (
    <section className='mb-6'>
      <h2 className='mb-4 text-2xl font-semibold'>Basic Configuration</h2>
      <Descriptions
        bordered
        column={1}
        labelStyle={{ width: '200px', fontWeight: 500 }}
        size='small'
      >
        <Descriptions.Item label='ClusterA'>
          <div className='flex items-center gap-2'>
            <div
              className='w-3 h-3 rounded'
              style={{ backgroundColor: ColorType.ORANGE }}
            />
            <span>
              {data.clusterID1}
              {cluster1?.name ? ` [${cluster1.name}]` : ''}
            </span>
          </div>
        </Descriptions.Item>
        <Descriptions.Item label='ClusterB'>
          <div className='flex items-center gap-2'>
            <div
              className='w-3 h-3 rounded'
              style={{ backgroundColor: ColorType.BLUE_3 }}
            />
            <span>
              {data.clusterID2}
              {cluster2?.name ? ` [${cluster2.name}]` : ''}
            </span>
          </div>
        </Descriptions.Item>
        <Descriptions.Item label='ClusterA Time Range'>
          {data.endTime1 !== undefined
            ? `${dayjs
                .unix(data.startTime1 ?? 0)
                .format('YYYY-MM-DD HH:mm:ss')} ~ ${dayjs
                .unix(data.endTime1 ?? 0)
                .format('YYYY-MM-DD HH:mm:ss')}`
            : '-'}
        </Descriptions.Item>
        <Descriptions.Item label='ClusterB Time Range'>
          {data.endTime2 !== undefined
            ? `${dayjs
                .unix(data.startTime2 ?? 0)
                .format('YYYY-MM-DD HH:mm:ss')} ~ ${dayjs
                .unix(data.endTime2 ?? 0)
                .format('YYYY-MM-DD HH:mm:ss')}`
            : '-'}
        </Descriptions.Item>
        <Descriptions.Item label='Duration'>
          {data.overAllDiff !== undefined
            ? formatDuration(data.overAllDiff)
            : '-'}
        </Descriptions.Item>
        <Descriptions.Item label='Datetime Diff'>
          {data.datetimeDiff !== undefined
            ? formatDuration(data.datetimeDiff)
            : '-'}
        </Descriptions.Item>
      </Descriptions>
    </section>
  )
}
